import { Component, OnInit, Input, ChangeDetectionStrategy,ViewChild, Inject } from '@angular/core';
import { slideInDownAnimation } from '../../../app/app.animation';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as AuthenticationActionTypes from '../../../screens/login/state/login.actions';
import * as fromAuthentication from '../../../screens/login/state/login.selectors';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'login-detail-component',
    templateUrl: './login-detail.component.html',
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginDetailComponent implements OnInit {
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @Input() isTryAgain: boolean;
    public displayedColumns = ['select', 'requestNo', 'orgInfoName', 'subsection', 'dateApproved', 'paymentOption', 'totalAmount', 'status', 'action'];
    datePipe = new DatePipe('en-US');
    localData: any[] = [];
    selection = new SelectionModel<any>(true, []);
    selectedRequests = [];
    externalLoginForm: any;
    isShowVAlidate = false;
    selectedCheckRequests = [];
    selectedCreditRequests = [];
    selectedPaymentValue = '';
    forgotLink: string = "";

    constructor(
        private store: Store<fromAuthentication.State>,
        private dialogRef: MatDialogRef<LoginDetailComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder
    ) {
        this.isTryAgain = data.isTryAgain;
        this.createForms()
        if (environment.API_URL.includes('lkeportal')) {
            this.forgotLink = "https://contributions.lge-ku.com/CCMS/#/forgot-password";
        } else {
            this.forgotLink = `${environment.APP_URL}/CCMS/#/forgot-password`
        }
    }

    public ngOnInit() {
        // this.startSubscriptions();

    }

    private createForms(): void {
        this.externalLoginForm = this.fb.group({
            email: ['', [Validators.required, Validators.minLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/))]],
            password: ['', [Validators.required, Validators.minLength(3)]]
        });
    }


    login(): void {
        let extLogin = { username: this.externalLoginForm.value['email'], password: this.externalLoginForm.value['password'] }
        this.store.dispatch(new AuthenticationActionTypes.Login(extLogin));
        this.dialogRef.close(true);
    }

    logout(): void {
        let extLogin = { username: this.externalLoginForm.value['email'], password: this.externalLoginForm.value['password'] }
        this.store.dispatch(new AuthenticationActionTypes.Logout());
        this.dialogRef.close(false);
    }

}
